import ApiClient from "../helpers/ApiClient";

export async function getOrders() {
    try {
        const res = await ApiClient.get(`/orders?_t=${Date.now()}`);
        return res;
    } catch (error) {
        throw error;
    }
}

export async function getOrdersInit() {
    try {
        const res = await ApiClient.get("/orders/init");
        return res;
    } catch (error) {
        throw error;
    }
}

export async function updateKitchenOrderItemStatus(
    orderItemId,
    status,
    cancelReason = null,
    cancelQuantity = null
) {
    try {
        const response = await ApiClient.post(`/orders/update-status/${orderItemId}`, {
            status,
            cancelReason,
            cancelQuantity
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export async function updateKitchenOrderItemComplementaryStatus(
    orderItemId,
    isComplementary
) {
    try {
        const response = await ApiClient.post(`/orders/update-complementary/${orderItemId}`, {
            isComplementary
        });
        return response;
    } catch (error) {
        throw error;
    }
}

/**
 * @param {Array<Number>} orderIds - list of orders to cancel
 *  */
export async function cancelKitchenOrder(
    orderIds,
    cancelReason
) {
    try {
        const response = await ApiClient.post(`/orders/cancel`, {
            orderIds,
            cancelReason
        });
        return response;
    } catch (error) {
        throw error;
    }
}

/**
 * @param {Array<Number>} orderIds - list of orders to cancel
 *  */
export async function completeKitchenOrder(
    orderIds,
) {
    try {
        const response = await ApiClient.post(`/orders/complete`, {
            orderIds
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export async function getCompleteOrderPaymentSummary(orderIds) {
    try {
        const res = await ApiClient.post("/orders/complete-order-payment-summary", {
            orderIds
        });
        return res;
    } catch (error) {
        throw error;
    }
}

export async function getInvoiceIdFromOrderId(orderIds) {
    try {
        const res = await ApiClient.post("/orders/get-invoice-id", {
            orderIds
        });
        return res;
    } catch (error) {
        throw error;
    }
}

/**
 * @param {Array<Number>} orderIds - list of orders to cancel
 * @param {Number} subTotal
 * @param {Number} taxTotal
 * @param {Number} total
 *  */
export async function payAndCompleteKitchenOrder(
    orderIds,
    subTotal,
    taxTotal,
    serviceChargeTotal,
    total,
    selectedPaymentType,
    discount = 0,
    paidAmount,
    loyaltyRedemptionAmount = 0,
    loyaltyPointsRedeemed = 0,
    loyaltyItemsRedeemed = 0,
    multiPayments = [],
    customer_id = null,
    roundOff = 0,
    itemPrices = []
) {
    try {
        const response = await ApiClient.post(`/orders/complete-and-pay-order`, {
            orderIds,
            subTotal, taxTotal, serviceChargeTotal, total,
            selectedPaymentType,
            discount,
            roundOff,
            paidAmount,
            loyaltyRedemptionAmount,
            loyaltyPointsRedeemed,
            loyaltyItemsRedeemed,
            multiPayments,
            customer_id,
            itemPrices
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export async function updateOrderItemPrices(itemPrices) {
    try {
        const response = await ApiClient.post("/orders/update-item-prices", {
            itemPrices
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export async function getOrderTables() {
  try {
    const response = await ApiClient.get('/orders/tables');
    return response;
  } catch (error) { throw error; }
}

export async function changeOrderTable(orderIds, newTableId) {
  try {
    const response = await ApiClient.post('/orders/change-table', { orderIds, newTableId });
    return response;
  } catch (error) { throw error; }
}

export async function mergeOrderTables(sourceTableIds, targetTableId, sourceOrderIds = []) {
  try {
    const response = await ApiClient.post('/orders/merge-tables', { sourceTableIds, targetTableId, sourceOrderIds });
    return response;
  } catch (error) { throw error; }
}

export async function splitOrderBill(originalOrderId, splits) {
  try {
    const response = await ApiClient.post('/orders/split-bill', { originalOrderId, splits });
    return response;
  } catch (error) { throw error; }
}

export async function acceptDeliveryOrder(orderId) {
  try {
    const response = await ApiClient.post(`/delivery/accept-order/${orderId}`);
    return response;
  } catch (error) { throw error; }
}
